import { Factory } from 'rosie';

const customerId = 'example/customer-id';

Factory.define('CustomerCombine').attr('name', 'CUSTOMER_COMBINE');

Factory.define('CustomerCombineWithDefaults').extend('CustomerCombine').attr('customerId', customerId);
